import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environments/environment';
import { IPolPayload, IPolResponse } from '../../models/life-check';
import { CameraService } from 'src/app/shared/services/camera.service';

/**
 * Configuración de calidad de video según el preset
 */
interface IVideoQualityConfig {
	width: number;
	height: number;
	frameRate: number;
}

const VIDEO_QUALITY_PRESETS: Record<'ULTRA' | 'HIGH' | 'MEDIUM' | 'LOW' | 'CUSTOM', IVideoQualityConfig> = {
	ULTRA: { width: 1920, height: 1080, frameRate: 30 },
	HIGH: { width: 1280, height: 720, frameRate: 30 },
	MEDIUM: { width: 854, height: 480, frameRate: 24 },
	LOW: { width: 640, height: 360, frameRate: 15 },
	CUSTOM: { width: 640, height: 480, frameRate: 30 },
};

@Injectable({
	providedIn: 'root',
})
export class LifeCheckService extends ApiService {
	private cameraService = inject(CameraService);

	constructor() {
		super();
	}

	public sendLifeCheckResult(body: IPolPayload): Observable<IPolResponse> {
		return this.http.post<IPolResponse>(environment.identity2 + `/liveness`, body, { headers: this.getHeaders() });
	}

	get constraints(): MediaStreamConstraints {
		const quality = environment.videoQuality || 'HIGH';
		const qualityConfig = VIDEO_QUALITY_PRESETS[quality];

		return {
			video: {
				facingMode: {
					ideal: 'user',
				},
				width: { ideal: qualityConfig.width },
				height: { ideal: qualityConfig.height },
				frameRate: { ideal: qualityConfig.frameRate },
				aspectRatio: { ideal: 16 / 9 },
			},
			audio: this.cameraService.shouldIncludeAudio(),
		};
	}
}
